/* eslint-disable no-param-reassign */
export default function ($sessionStorage, $state, $log, $timeout, DrawpService) {
    const months = ['Jan', 'Feb', 'Mar', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    const stamp = new Date().getTime();
    const subscriptionDataKey = `subscriptionData_${stamp}`;

    $sessionStorage.addonKey = subscriptionDataKey;

    return {
        restrict: 'E',
        transclude: true,
        scope: {
            'title': '@',
            'subtitle': '@',
            'backState': '@',
            'customClass': '@',
            'hidePremiumBadge': '@',
            'hideThreeDots': '@',
            'toolId': '@',
        },
        /* eslint-disable no-param-reassign */
        link: (scope, element) => {
            // scope.subscriptionData = $sessionStorage[subscriptionDataKey];

            const subscriptionInfoDialogEl = mdc.dialog.MDCDialog.attachTo(document.querySelector('#subscription_info_dialog'));
            let cancelSubscriptionEl = null;

            scope.navigateBack = () => {
                $state.go(scope.backState);
            };

            // scope.getSubscriptionData = (toolId) => {
            //     // if (!scope.subscriptionData) {
            //     google.script.run.withSuccessHandler((text) => {
            //         if (text != null) {
            //             scope.subscriptionData = {};
            //             const data = JSON.parse(text);
            //             scope.subscriptionData.is_renew_toggle_available = true;
            //             scope.subscriptionData.cancel_at_period_end = false;
            //             scope.subscriptionData.subscriptionDaysLeft = null;
            //             scope.subscriptionData.subscriptionExpiryDate = null;

            //             if (data.domain_enabled) {
            //                 scope.subscriptionData.subscription = data.domain_enabled;
            //                 scope.subscriptionData.is_renew_toggle_available = false;
            //             } else {
            //                 scope.subscriptionData.subscription = data.subscription_days_left != null && data.subscription_days_left > 0;
            //             }

            //             if (data.cancel_at_period_end != null) {
            //                 scope.subscriptionData.cancel_at_period_end = !data.cancel_at_period_end;
            //             } else {
            //                 scope.subscriptionData.is_renew_toggle_available = false;
            //             }

            //             if (data.subscription_due_on != null) {
            //                 scope.subscriptionData.subscriptionDaysLeft = data.subscription_days_left;

            //                 const date = new Date(data.subscription_due_on.replace(' ', 'T'));
            //                 const ampm = date.getHours() >= 12 ? 'pm' : 'am';

            //                 let minutes = date.getMinutes();
            //                 if (minutes < 10) {
            //                     minutes = `0${minutes}`;
            //                 }

            //                 scope.subscriptionData.subscriptionExpiryDate = `${months[date.getMonth()]} ${date.getDate().toString()} ${date.getFullYear().toString()} at ${date.getHours()}:${minutes} ${ampm}`;
            //             }

            //             scope.$apply();

            //             $sessionStorage[subscriptionDataKey] = scope.subscriptionData;
            //             $log.info('Subscription data has been loaded successfully.');
            //             scope.$apply();
            //         }
            //     }).withFailureHandler((error) => {
            //         scope.subscriptionData = null;
            //         $log.error('An error has occurred while fetching the subscription data.', error);
            //     }).getSubscriptionData(toolId);
            //     // }
            // };

            // scope.getSubscriptionData(scope.toolId);

            scope.showSubscriptionDetail = () => {

                $state.go('activeSubscriptionsList');
            };

            // scope.cancel_at_period_end_change = () => {
            //     google.script.run.withSuccessHandler(() => {
            //         $log.info('renewSubscriptionToggle success!');
            //     }).renewSubscriptionToggle(cancelSubscriptionEl.checked, scope.toolId);
            // };

            // scope.$watch('toolId', (newValue) => {
            //     scope.getSubscriptionData(newValue);
            // });

            scope.userEmail = localStorage.getItem('drawp-userEmail') != null ? localStorage.getItem('drawp-userEmail') : '';
            scope.serverToken = localStorage.getItem('drawp-serverToken') != null ? localStorage.getItem('drawp-serverToken') : '';

            scope.$on('ACCOUNT_CHANGE', () => {
                $timeout(() => {
                    scope.userEmail = localStorage.getItem('drawp-userEmail') != null ? localStorage.getItem('drawp-userEmail') : '';
                    scope.serverToken = localStorage.getItem('drawp-serverToken') != null ? localStorage.getItem('drawp-serverToken') : '';
                });
            });

            scope.goToLogin = function () {
                DrawpService.openLoginDialog();
            };

            scope.goToSubscriptions = function () {
                $state.go('activeSubscriptionsList');
            };

            scope.logOut = function () {
                DrawpService.logOut();
                $state.go($state.current.name, {}, { reload: true });
            };

            scope.getDisplayEmail = function (email) {
                if (!email) return '';
                const atIdx = email.indexOf('@');
                if (atIdx === -1) return email.length > 13 ? email.slice(0, 10) + '...' : email;

                let name = email.slice(0, atIdx);
                let domain = email.slice(atIdx + 1);

                if (domain.length > 10) {
                    name = name.slice(0, 6) + '...';
                    return name + domain;
                }
                if (name.length > 20) return name.slice(0, 10) + '...' + '@' + domain;
                return name + '@' + domain;
            };

            let headerMenu = null;
            scope.initHeaderMenu = () => {
                const menuElement = element[0].querySelector('.nav-header-menu');
                const extMenuElement = element[0].querySelector('.nav-header-menu-button');
                if (menuElement && extMenuElement) {
                    headerMenu = new mdc.menu.MDCMenu(menuElement);
                    headerMenu.setAnchorElement(extMenuElement);
                }
            };

            scope.toggleHeaderMenu = ($event) => {
                if (!headerMenu) {
                    scope.initHeaderMenu();
                }
                if (headerMenu) {
                    const button = $event.currentTarget;
                    headerMenu.setAnchorElement(button);
                    headerMenu.open = !headerMenu.open;
                }
            };
        },
        template: `<div class="navigation-header-container {{customClass}}">
                        <div class="navigation-section">
                            <div class="material-icons nav-back-icon"
                                ng-click="navigateBack();" ng-class="{'backbutton-hidden': !backState}">arrow_back
                            </div>
                            <div>
                                <div class="header-title">{{title}}</div>
                                <div class="header-subtitle" ng-if="subtitle">{{subtitle}}</div>
                            </div>
                        </div>

                        <div class="nav-header-actions-section">
                            <div class="premium-badge-section" ng-hide="hidePremiumBadge">
                                <span class="material-icons premium-icon"
                                ng-show="subscriptionData.subscription"
                                ng-click="showSubscriptionDetail();"title="Premium">
                                verified</span>
                            </div>
                            
                            <div class="mdc-menu-surface--anchor nav-header-menu-anchor" ng-if="hideThreeDots !== 'true'">
                                <span class="material-icons action-icon nav-header-menu-button" ng-click="toggleHeaderMenu($event)" style="color: #fff; cursor: pointer; margin-top: 12px;">
                                    more_vert
                                </span>
                                <!-- MDC Menu -->
                                <div class="mdc-menu mdc-menu-surface nav-header-menu">
                                    <ul class="mdc-list" role="menu" aria-hidden="true" aria-orientation="vertical" tabindex="-1" style="padding: 0;">
                                        <!-- Logged Out State -->
                                        <li class="mdc-list-item" role="menuitem" ng-if="!userEmail" ng-click="goToLogin()" style="padding: 8px 16px !important; color: #43af71; cursor: pointer; font-weight: normal;">
                                            Log In
                                        </li>
                                        
                                        <!-- Logged In State -->
                                        <li class="mdc-list-item mdc-list-item--disabled" role="menuitem" ng-if="userEmail" style="padding: 8px 16px !important; opacity: 0.8; font-size: 11px; pointer-events: none; line-height: 1.3; font-weight: normal; border-bottom: 1px solid #eee;">
                                            <span style="line-height: 1.3; font-weight: normal;">Logged in as <strong style="word-break: break-all;">{{getDisplayEmail(userEmail)}}</strong></span>
                                        </li>
                                        <li class="mdc-list-item" role="menuitem" ng-if="userEmail" ng-click="goToSubscriptions()" style="padding: 8px 16px !important; font-weight: normal; color: #42b070; cursor: pointer; font-size: 0.8rem">
                                            View Subscriptions
                                        </li>
                                        <li class="mdc-list-item" role="menuitem" ng-if="userEmail" ng-click="logOut()" style="padding: 8px 16px !important; font-weight: normal; color: #42b070; cursor: pointer; font-size: 0.8rem">
                                            Log Out
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="mdc-dialog" id="subscription_info_dialog">
                        <div class="mdc-dialog__container">
                            <div class="mdc-dialog__surface" role="alertdialog" aria-modal="true" aria-labelledby="my-dialog-title"
                                aria-describedby="my-dialog-content">
                                <div class="mdc-dialog__content" id="my-dialog-content">
                                    <div class="row form-element">
                                        <div class="col-md-12">
                                            <p class="subscription-message" ng-if="subscriptionData.subscriptionDaysLeft==null">You have unlimited premium
                                                access to the Drawp for School
                                                Add-on
                                                Tool.</p>
                                            <p class="subscription-message" ng-if="subscriptionData.subscriptionDaysLeft<0">Your subscription has expired.
                                            </p>
                                            <p class="subscription-message" ng-if="subscriptionData.subscriptionDaysLeft>0">Your premium subscription expires
                                                on
                                                <b>{{ subscriptionData.subscriptionExpiryDate }}</b>
                                            </p>
                                        </div>

                                        <div class="col-md-12" ng-if="subscriptionData.is_renew_toggle_available">
                                            <div class="mdc-card subscrition-card" id="mdc-card-toggle">
                                                <div class="row">
                                                    <div class="col-9 switch-main-div">
                                                        <span class="switch-title" style="display: block;">Auto Renew Subscription</span>
                                                        <p class="switch-subtitle" ng-if="subscriptionData.cancel_at_period_end">Your subscription will be
                                                            auto
                                                            renewed after expiry.</p>
                                                        <p class="switch-subtitle" ng-if="!subscriptionData.cancel_at_period_end">Your subscription will NOT
                                                            be auto renewed after expiry.</p>
                                                    </div>

                                                    <div class="col-3 align-self-center">
                                                        <div class="mdc-switch mdc-switch--checked" id="cancel-subscription-switch">
                                                            <div class="mdc-switch__track"></div>
                                                            <div class="mdc-switch__thumb-underlay">
                                                                <div class="mdc-switch__thumb"></div>
                                                                <input type="checkbox" id="basic-switch" class="mdc-switch__native-control"
                                                                    role="switch" aria-checked="false" ng-model="subscriptionData.cancel_at_period_end"
                                                                    ng-change="cancel_at_period_end_change()">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mdc-dialog__actions">
                                    <button type="button" class="mdc-button mdc-dialog__button" data-mdc-dialog-action="cancel">
                                        <div class="mdc-button__ripple"></div>
                                        <span class="mdc-button__label">Done</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="mdc-dialog__scrim"></div>
                    </div>`
    };
}